module.exports = __webpack_public_path__ + "static/fiji3-150x150-561e08db89f0e496f241723977950ee7.png";